import {gql} from '@apollo/client'

export const PHONE_NUMBER_FRAGMENT = gql`
  fragment PhoneNumberFragment on PhoneNumber {
    id
    number
    nationalNumber
    primary
    preferredMessageMode
    status
    tfaConfigId
    createdAt
    updatedAt
  }
`

export const TFA_PHONE_NUMBER_FRAGMENT = gql`
  fragment TfaPhoneNumberFragment on TfaPhoneNumber {
    id
    confirmationError
    number
    nationalNumber
    primary
    preferredMessageMode
    status
    tfaConfigId
  }
`

export const TFA_ENROLLMENT_FRAGMENT = gql`
  fragment TfaEnrollmentFragment on TfaEnrollment {
    id
    name
    mode
    category
    provisioningUri
    enabledAt
    lastUsedAt
  }
`

export const TFA_CONFIG_FRAGMENT = gql`
  ${PHONE_NUMBER_FRAGMENT}
  fragment TfaConfigFragment on TfaConfig {
    id
    userId
    status
    primaryNumber {...PhoneNumberFragment}
    secondaryNumber {...PhoneNumberFragment}
    lastEnabledAt
  }
`
